import { render, staticRenderFns } from "./PackageTracking.vue?vue&type=template&id=5167e664&scoped=true"
import script from "./PackageTracking.vue?vue&type=script&lang=js"
export * from "./PackageTracking.vue?vue&type=script&lang=js"
import style0 from "./PackageTracking.vue?vue&type=style&index=0&id=5167e664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167e664",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/PackageTracking.vue
// module id = 2087
// module chunks = 31